import { MapsAPILoader } from '@agm/core';
import { Component } from '@angular/core';
import { MathService } from '../core/services/math.service';
@Component({
  selector: 'app-catersiano',
  templateUrl: './cartesiano.component.html',
  styleUrls: ['./cartesiano.component.scss'],
})
export class CartesianoComponent {
  title = 'map';
  public point1 = null;
  public point2 = null;
  public pointFinal = null;
  constructor(
    private _mathService: MathService,
    private mapsAPILoader: MapsAPILoader
  ) {
  }

}
